import { LobbyEntryService } from './../../../lobby/shared/services/lobby-entry.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';
import { MessageHubService } from 'src/app/shared/services/message-hub.service';
import * as MessageHubActions from '../../../state/actions/message-hub.actions';
import * as AppointmentStatusGridActions from './actions/appointment-status-grid.actions';
import * as AppointmentStatusGridApiActions from './actions/appointment-status-grid-api.actions';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AppointmentService } from '../../shared/services/appointment.service';
import { ExternalRouteServiceService } from 'src/app/shared/services/external-route-service.service';

@Injectable()
export class AppointmentStatusGridEffects {

    constructor(private actions$: Actions,
                private messageHubService: MessageHubService,
                private lobbyEntryService: LobbyEntryService,
                private appointmentService: AppointmentService,
                private toastService: ToastService,
                private externalRouteServiceService: ExternalRouteServiceService) { }

    subscribeTOCentralLocationGridViewData$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(AppointmentStatusGridActions.subscribeToAppointmentStatusGridData),
                switchMap(action => {
                    this.messageHubService.subscribeToAppointmentGridGroup(action.appointmentStatusGridFilter);
                    return of(MessageHubActions.joinAppointmentStatusGridActionComplete());
                })
            );
    });

    addToLobby$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(AppointmentStatusGridActions.checkInAppointmentToLobby),
                concatMap(action =>
                    this.lobbyEntryService.addToLobby(action.lobbyCheckIn)
                        .pipe(
                            map(lobbyEntryId => AppointmentStatusGridApiActions.addToLobbySuccess({ lobbyEntryId })),
                            tap(() => this.toastService.showSuccess('_Appointment_Status_Appointment_CheckedIn_Successfully_Ts_Text_')),
                            catchError(error => {
                                this.toastService.showError('_Appointment_Status_Appointment_CheckIn_Failed_Ts_Text_');
                                return of(AppointmentStatusGridApiActions.addToLobbyFailure({ error }));
                            })
                        )
                    )
            );
    });

    updateAppointmentStatusToNoShow$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(AppointmentStatusGridActions.updateAppointmentStatusToNoShow),
                concatMap(action =>
                    this.appointmentService.updateAppointmentStatus(action.confirmationNumber, 'NOSHOW')
                        .pipe(
                            map(() => AppointmentStatusGridApiActions.updateAppointmentStatusSuccess()),
                            tap(() => this.toastService.showSuccess('_Appointment_Status_Appointment_Updated_To_No_Show_Ts_Text_')),
                            catchError(error => {
                                this.toastService.showError('_Appointment_Status_Appointment_Updated_To_No_show_Failed_Ts_Text_');
                                return of(AppointmentStatusGridApiActions.updateAppointmentStatusFailure({ error }));
                            })
                        )
                    )
            );
    });

    openAppointmentWidget$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(AppointmentStatusGridActions.routeToAppointmentWidget),
                switchMap(action => {
                    this.externalRouteServiceService.routeToAcAppointmentConfirmation(action.confirmationNumber);
                    return of(MessageHubActions.routeToAppointmentWidgetComplete());
                })
            );
    });
}
